"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reduxForm = require("redux-form");

var _Component = _interopRequireDefault(require("./Component"));

var validate = function validate(values) {
  var errors = {};

  if (!values["amount"]) {
    errors["amount"] = "Обязательное поле";
  } else {
    var amount = Number(values['amount']);
    var finalAmount = Number(values['finalAmount']);

    if (amount <= 0 || !/^(\d+)(\.\d{1,2})?$/.test(String(amount))) {
      errors["amount"] = "Неверный формат суммы";
    } else if (amount > finalAmount) {
      errors["amount"] = "\u0421\u0443\u043C\u043C\u0430 \u043D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 ".concat(finalAmount);
    }
  }

  return errors;
};

var _default = (0, _reduxForm.reduxForm)({
  form: 'auth-invoice',
  validate: validate
})(_Component["default"]);

exports["default"] = _default;